import React from 'react';
import { XIcon } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'Juice Cleanses',
    description: 'Spike your insulin, causing your body to store even more water.'
  }, {
    title: 'Laxative Teas',
    description: 'Irritate your gut lining and lead to dangerous dehydration.'
  }, {
    title: 'Fasting Alone',
    description: 'Stresses your system, triggering a cortisol spike that keeps the bloat locked in place.'
  }, {
    title: '"Healthy" Salads',
    description: 'Contain raw fibers that are too tough for a stressed gut to break down right now.'
  }];
  return <section className="py-24 bg-stone-50" data-id="element-18">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="text-center mb-16" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-serif text-stone-900 mb-4" data-id="element-21">
            Why What You Tried Didn't Work
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto" data-id="element-22">
            Standard "detox" advice actually triggers your body's defense
            mechanisms, making the bloating worse.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-23">
          {failures.map((item, index) => <div key={index} className="bg-white p-8 rounded-xl border border-stone-200 shadow-sm flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-24">
              <div className="flex-shrink-0 mt-1" data-id="element-25">
                <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center" data-id="element-26">
                  <XIcon className="w-5 h-5 text-red-500" data-id="element-27" />
                </div>
              </div>
              <div data-id="element-28">
                <h3 className="text-xl font-serif font-medium text-stone-900 mb-2" data-id="element-29">
                  {item.title}
                </h3>
                <p className="text-stone-600 leading-relaxed" data-id="element-30">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}